<template>
  <Pie
      id="errorDistributionChart"
      :options="chartOptions"
      :data="chartData"
  />
</template>

<script setup>
import {defineExpose, ref} from 'vue';
import {Pie} from 'vue-chartjs';
import {ArcElement, Chart as ChartJS, Tooltip} from 'chart.js'

ChartJS.register(ArcElement, Tooltip)

const chartData = ref({
  labels: [],
  datasets: []
});

const chartOptions = ref({
  responsive: true,
  maintainAspectRatio: true,
  elements: {
    arc: {
      borderWidth: .5
    }
  },
  plugins: {
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      usePointStyle: true,
      callbacks: {
        label: function (context) {
          return context.parsed + '%';
        }
      }
    }
  }
});

const updateData = (errors) => {
  if (errors?.length <= 0) {
    chartData.value = {
      labels: ['Sem dados'],
      datasets: [{
        label: '',
        data: [100],
        backgroundColor: ['rgb(211, 211, 211)']
      }]
    };
    return;
  }

  chartData.value = {
    labels: errors?.map(e => e.title),
    datasets: [{
      label: '',
      data: errors?.map(e => e.value),
      backgroundColor: [
        'rgb(7, 40, 94)',
        'rgb(13, 58, 122)',
        'rgb(19, 76, 150)',
        'rgb(25, 94, 178)',
        'rgb(31, 112, 206)',
        'rgb(62, 112, 194)',
        'rgb(38, 128, 158)',
        'rgb(44, 146, 166)',
        'rgb(52, 165, 175)',
        'rgb(52, 189, 217)',
        'rgb(29, 145, 218)',
        'rgb(18, 117, 201)',
        'rgb(24, 97, 170)',
        'rgb(30, 77, 139)',
        'rgb(36, 57, 108)',
        'rgb(48, 84, 132)',
        'rgb(60, 111, 156)',
        'rgb(72, 138, 180)',
        'rgb(84, 165, 204)',
        'rgb(96, 192, 228)'
      ],
    }]
  };
}

defineExpose({
  updateData
})
</script>

<style scoped>

</style>
